import axios from 'axios';
import { ECOMMERCE_CONFIG, ecommerceError } from '../../config/EcommerceConfig';

/**
 * Servicio para obtener categorías públicas del e-commerce
 * Conecta con CategoriaController del backend
 */
export const EcommerceCategoriaService = {
    /**
     * Obtiene todas las categorías de una empresa (sin autenticación)
     * @param {number} idEmpresa - ID de la empresa
     * @returns {Promise<Array>} Lista de categorías
     */
    obtenerCategorias: async (idEmpresa = ECOMMERCE_CONFIG.EMPRESA_ID) => {
        try {
            const url = `${ECOMMERCE_CONFIG.API_BASE_URL}/api/categorias/public/empresa/${idEmpresa}`;
            
            const response = await axios.get(url, {
                timeout: ECOMMERCE_CONFIG.REQUEST_TIMEOUT
            });
            
            // Validar que la respuesta sea correcta
            if (response.data?.success && response.data?.data) {
                return response.data.data;
            }
            ecommerceError('Respuesta inválida del servidor', response.data);
            return [];
        } catch (error) {
            ecommerceError(`Error al obtener categorías: ${error.message}`, error);
            throw error;
        }
    },

    /**
     * Busca categorías por descripción
     * @param {number} idEmpresa - ID de la empresa
     * @param {string} descripcion - Término de búsqueda
     * @returns {Promise<Array>} Categorías encontradas
     */
    buscarCategorias: async (idEmpresa = ECOMMERCE_CONFIG.EMPRESA_ID, descripcion) => {
        try {
            const url = `${ECOMMERCE_CONFIG.API_BASE_URL}/api/categorias/buscar?idEmpresa=${idEmpresa}&descripcion=${encodeURIComponent(descripcion)}`;
            
            const response = await axios.get(url, {
                timeout: ECOMMERCE_CONFIG.REQUEST_TIMEOUT
            });
            
            if (response.data?.success && response.data?.data) {
                return response.data.data;
            }
            return [];
        } catch (error) {
            ecommerceError(`Error en búsqueda de categorías: ${error.message}`, error);
            throw error;
        }
    }
};
